<template lang="pug">
  #my-friends
    .my-friends-header.level.is-mobile
      .level-left
        .level-item
          BField
            BInput(
              placeholder="Filter friends..."
              custom-class="is-rounded"
              type="search"
              icon="filter"
              v-model="query"
            )
    .empty-state(v-if="_.isEmpty(filteredFriends)")
        p Hey there, seems like we can't find that friend.
    .friends-gallery()
      section.section
        .columns.is-multiline.is-centered
          template(v-for="friend in filteredFriends")
            .column.is-3
              .box.has-shadow
                .columns.is-mobile.is-centered.is-multiline.has-text-centered
                  .column.is-full-tablet.is-half-mobile
                  EntityAvatar(:image="friend.avatar" is-rounded)
                  .column.is-full-tablet.is-half-mobile
                    .is-size-4(v-if="coreProgramMeta.showRealNames" ) {{ friend.name }}
                    div
                      WtRouterLink(
                        to="ProfilePage"
                        :params="{ username: friend.username }"
                        :text="'@'+friend.username"
                      )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtAddFriendButton from "@@/WtAddFriendButton/WtAddFriendButton";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";
import UserCardActionsMenu from "@/components/Members/UserCardActionsMenu";

export default {
  name: "ProfileMyFriends",

  components: {
    EntityAvatar,
    WtRouterLink,
    WtTitle,
    WtAddFriendButton,
    WtButton,
    UserCardActionsMenu
  },

  props: {
    memberFriends: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      query: ""
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    filteredFriends() {
      return this.memberFriends.filter(friend => {
        if (this.coreProgramMeta.showRealNames) {
          return (
            friend.username.toLowerCase().indexOf(this.query.toLowerCase()) >
              -1 ||
            friend.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1
          );
        } else {
          return (
            friend.username.toLowerCase().indexOf(this.query.toLowerCase()) > -1
          );
        }
      });
    }
  },

  methods: {
    ...mapActions("members", ["fetchFriends"])
  }
};
</script>

<style lang="sass" scoped>
#my-friends
  .friends-gallery
    .media
      width: 0 // needed for IE11 fix
    .box.has-shadow
      box-shadow: 0 12px 24px 0 rgba(0,0,0,0.1)
    .wt-entity-avatar
      display: flex
      justify-content: center
  .box
    position: relative
</style>
